// Styles
import { paletas } from "../../styles/theme";
import { Wrapper, BotaoFechar } from "./styles";
import Botao from "../botao";

// Icon
import { AiOutlineClose } from "react-icons/ai";
import { GiStarFormation, GiArtificialIntelligence } from "react-icons/gi";

type ModalProps = {
  frase: string;
  recompensa: string;
  respostaCorreta: boolean;
  valorBotao: string;
  fechar: () => any;
  onClick: () => any;
};

export default function Modal({
  frase,
  recompensa,
  onClick,
  respostaCorreta,
  valorBotao,
  fechar,
}: ModalProps) {
  return (
    <Wrapper>
      <BotaoFechar onClick={fechar}>
        <AiOutlineClose color={paletas.White} />
      </BotaoFechar>
      <div>
        <div className="wrapperIcon">
          {respostaCorreta ? (
            <GiStarFormation color={paletas.Gold} size="50px" />
          ) : (
            <GiArtificialIntelligence color={paletas.Lightyellow} size="50px" />
          )}
        </div>
        <p>{frase}</p>
        <p>{recompensa}</p>
      </div>
      <Botao
        type="button"
        value={valorBotao}
        background={paletas.Grafite75}
        color={paletas.White}
        border="transparent"
        size="18px"
        disabled={false}
        onClick={onClick}
      />
    </Wrapper>
  );
}
